import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Avatar,
  Stack,
  IconButton,
  StepLabel,
  Step,
  Stepper,
  CircularProgress,
  Snackbar,
  Alert,
  Button,
  Chip,
  Badge,
  Popover,
  FormControl,
  Select,
  MenuItem,
  Tabs,
  Tab,
  Pagination,
  Modal,
} from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useApi from "../../Utilities/useAPI";
import { useUserDetailContext } from "../../UserDetailContext";
// import Avatar from '@mui/material/Avatar';
import AvatarGroup from "@mui/material/AvatarGroup";
import JobOpenings from "./SideFeedComponents/JobOpenings";
import axios from "axios";
import CryptoJS from "crypto-js";
import JobDescriptionSidebar from "./JobDescriptionSidebar";
import {
  Link,
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import UpcomingEvents from "./SideFeedComponents/UpcomingEvents";
import { useProfileContext } from "../../ProfileDetailContext";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  updateJob,
  getInterviewRounds,
  setCurrentCandidate,
  setCurrentUserRefId,
  getApplicants,
  getPostedJobs,
} from "../../../Redux/Reducers/JobReducer";
import { useQuantityContext } from "../../QuantityContext";
import Total from "../../../Assets/total.webp";
import Inreview from "../../../Assets/1.png";
import shortlist from "../../../Assets/2.png";
import interview from "../../../Assets/3.png";
import offer from "../../../Assets/4.png";
import reject from "../../../Assets/3.png";
import calender from "../../../Assets/calendar.webp";
import interviewed from "../../../Assets/interview.png";
import { getVisitingCardReducer } from "../../../Redux/Reducers/CardReducer";
import RecruiterJobs from "./RecruiterJobs";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CandidateCard from "./SideFeedComponents/CandidateCard";
import { offerStatuses } from "../../Utilities/ListUtils";
import MyVisitingCard from "./SideFeedComponents/MyVisitingCard";

const RecruiterDashBoard = () => {
  const { id } = useParams(); // Get jobId from URL
  const location = useLocation();
  // console.log("jobId", id)
  const dispatch = useDispatch();
  const { callApiFunction } = useApi();
  const [recruiterData, setRecruiterData] = useState([]);
  const { userDetails } = useUserDetailContext();
  const encryptedUrlRef = useRef("");
  // const [logourl, setLogourl] = useState({});
  // console.log("recruiterData",recruiterData)
  // console.log("userDetails",userDetails)
  // const [jobs, setJobs] = useState([]); // To store the job datas
  // console.log("jobs", jobs)
  const [loading, setLoading] = useState(false); // To handle loading state
  const [error, setError] = useState(null); // To handle errors
  // const [singleJob, setsingleJob] = useState();
  const [candidates, setCandidates] = useState([]);
  const viewedUserId = userDetails?.reference_id;
  const phoneNumber = userDetails?.phone.replace(/\s+/g, "");
  const emailId = userDetails?.email ? userDetails?.email : userDetails?.email;
  const objectId = localStorage.getItem("objectId");
  const [encryptedId, setEncryptedId] = useState("");
  // const { companyId, setCompanyId} = useProfileContext()
  // console.log("companyId", companyId)
  const navigate = useNavigate();
  const Jobs = useSelector((state) => state?.jobs?.postedJobsData) || [];
  const postedJobs = Jobs?.posted_jobs;
  const [showStatusConfirmation, setShowStatusConfirmation] = useState(false);
  const [selectedNewStatus, setSelectedNewStatus] = useState("");
  const singlePostedJob = useSelector((state) => state?.jobs?.singlePostedJob);
  const singleJob = singlePostedJob?.job;
  const jobApplications =
    useSelector((state) => state?.jobs?.jobApplications) || [];
  const jobApplicantsData =
    useSelector((state) => state?.jobs?.jobApplicantsData) || [];
  //  const applicants = useSelector((state) => state?.jobs?.applicants) || [];
  const applicants = jobApplicantsData?.applicants || [];

  const [showSnackbar, setShowSnackbar] = useState(false);
  const VisitCardProfessionalQrstyles = useSelector(
    (state) => state?.CardArray?.visitingCard?.professionalCardData?.qrStyles
  );
  // console.log("singleJob123", singleJob)
  const [selectedTab, setSelectedTab] = useState(0);
  const [singleJobId, setsingleJobId] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [showSelect, setShowSelect] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [jobStatus, setJobStatus] = useState(singleJob?.status || "Open");
  const { openSnackbar } = useQuantityContext();
  const hasFetched = useRef(false);
  const [page, setPage] = useState(1);
  const selectedCompany =
    useSelector((state) => state?.jobs?.selectedCompany) || {};

  // Add handler for pagination
  const handlePageChange = (event, value) => {
    setPage(value);
  };

  useEffect(() => {
    setJobStatus(singleJob?.status || "Open");
  }, [singleJob]);

  const getHeaders = useCallback(
    () => ({
      "x-api-key": process.env.REACT_APP_API_KEY,
      "Content-Type": "application/json",
      Authorization: `Bearer ${objectId}`,
    }),
    [objectId]
  );

  useEffect(() => {
    if (userDetails?.reference_id && !hasFetched.current) {
      const encryptedId = encodeURIComponent(
        CryptoJS.AES.encrypt(
          userDetails.reference_id.toString(),
          "UserDetailsSecretKey"
        ).toString()
      );
      
      dispatch(getVisitingCardReducer({ encryptedId }));
      // console.log("encryptedId", encryptedId, userDetails.reference_id);
      hasFetched.current = true; // Mark as fetched
    }
  }, [userDetails?.reference_id, dispatch]);

  const [professionalCardContacts, setProfessionalCardContacts] = useState({
    cardName: "Professional",
    mobile_number: "",
    call_visible: true,
    sms_visible: true,
    email_visible: true,
    whatsapp: "",
    whatsapp_visible: true,
  });

  const [professionalCardDetails, setProfessionalCardDetails] = useState({
    cardName: "Professional",
    userRefId: "",
    encryptedId: "",
    designation: "",
    firstName: "",
    email: "",
    phone_no: "",
    lastName: "",
    token: "",
    company: "",
    profile_pic: "",
    logo: "",
    defaultPhone: "",
    defaultEmail: "",
  });

  const cardDetails = professionalCardDetails;
  const cardContacts = professionalCardContacts;
  // const cardQrStyles = VisitCardProfessionalQrstyles;

  const cardQrStyles = {
    ...VisitCardProfessionalQrstyles,
    CardName: "Professional",
    eyeBall: "",
    eyeBallcolor: "",
    eyeFrame: "",
    eyeFrameColor: "",
    qrPattern: "",
    qrPatterncolor: "#121212",
    border: "",
    bordercolor: "",
    addbg: "",
    addbgcolor: "#ede8e8",
    logo: "",
  };

  console.log("singleJob", singleJob)

  const NoJobsFound = () => (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "150px",
        border: "1px dashed #ccc",
        borderRadius: 1,
        margin: "20px 0",
      }}
    >
      <Typography variant="h6" color="text.secondary">
        No Jobs Posted
      </Typography>
      <Typography variant="body2" color="text.secondary" mt={1}>
        Start by posting your first job
      </Typography>
    </Box>
  );

  const CustomNextArrowCandidates = ({ onClick }) => (
    <IconButton
      onClick={onClick}
      sx={{
        position: "absolute",
        top: "50%",
        right: "-10px", // Moved further right
        bgcolor: "#0044C61A",
        transform: "translateY(-50%)",
        color: "#0044C6",
        zIndex: 1,
        "&:hover": {
          bgcolor: "#d1e2ff",
          color: "#002699",
        },
      }}
    >
      <ArrowForwardIosIcon />
    </IconButton>
  );

  const CustomPrevArrowCandidates = ({ onClick }) => (
    <IconButton
      onClick={onClick}
      sx={{
        position: "absolute",
        top: "50%",
        bgcolor: "#0044C61A",
        alignSelf: "center",
        left: "-10px", // Moved further left
        transform: "translateY(-50%)",
        color: "#0044C6",
        zIndex: 1,
        "&:hover": {
          bgcolor: "#d1e2ff",
          color: "#002699",
        },
      }}
    >
      <ArrowBackIosIcon />
    </IconButton>
  );

  const getsingleJobStats = useMemo(() => {
    if (!singleJobId || !postedJobs) return null;
    return (
      postedJobs.find((job) => job?.id === singleJobId)?.applicantStats || {
        total: 0,
        applied: 0,
        shortlisted: 0,
        interviewed: 0,
        offerSent: 0,
        joined: 0,
        rejected: 0,
      }
    );
  }, [singleJobId, postedJobs]);

  const handleStatsClick = (item) => {
    // If no value, show message and return
    if (!Number(item?.value)) {
      openSnackbar(
        `There are currently no candidates available to view.`,
        "info"
      );
      return;
    }

    // Determine the status to use in API call
    let appStatus;

    if (item?.status == "Total") {
      appStatus = "";
    } else if (item?.status === "Offered") {
      appStatus = offerStatuses?.join("|");
    } else {
      appStatus = item?.status;
    }

    // Make API call with determined status
    dispatch(
      getApplicants({
        status: appStatus,
        job_id: singleJob?.id,
      })
    );

    setSelectedTab(1);
  };

  const handleViewAllCandidate = (selectedStatus) => {
    // console.log("selectedStatus", selectedStatus);
    navigate(`/all-candidatesinfo`);
  };

  const statsConfig = useMemo(
    () => [
      {
        label: "In Review",
        status: "In Review",
        value: singleJob?.applicantStats?.["In Review"] || 0,
        color: "#2196f3",
        image: offer,
      },
      {
        label: "Shortlisted",
        status: "Shortlisted",
        value: singleJob?.applicantStats?.Shortlisted || 0,
        color: "#4caf50",
        image: interview,
      },
      {
        label: "In Interview",
        status: "Interview In-Progress",
        value: singleJob?.applicantStats?.["Interview In-Progress"] || 0,
        color: "#ff9800",
        image: Inreview,
      },
      {
        label: "Selected",
        status: "Selected",
        value: singleJob?.applicantStats?.Selected || 0,
        color: "#ff9800",
        image: Inreview,
      },
      {
        label: "Offered",
        status: "Offered",
        value: Object.entries(singleJob?.applicantStats)
          ?.filter(([key, value]) => key.includes("Offer"))
          ?.reduce((acc, [key, value]) => acc + Number(value), 0),
        color: "#9c27b0",
        image: shortlist,
      },
      {
        label: "Joined",
        status: "Joined",
        value: singleJob?.applicantStats?.Joined || 0,
        color: "#009688",
        image: reject,
      },
      {
        label: "Rejected",
        status: "Rejected",
        value: singleJob?.applicantStats?.Rejected || 0,
        color: "#f44336",
        image: Inreview,
      },
      {
        label: "Not Joined",
        status: "Not Joined",
        value: singleJob?.applicantStats?.["Not Joined"] || 0,
        color: "#f44336",
        image: Inreview,
      },
    ],
    [singleJob]
  );

  const handleStatusClick = (event) => {
    setAnchorEl(event.currentTarget);
    setShowSelect(!showSelect);
  };

  const handleStatusClose = () => {
    setAnchorEl(null);
  };

  const params = useMemo(
    () => ({
      company: selectedCompany?.company_name,
    }),
    []
  );

  const handleStatusChange = async (newStatus) => {
    try {
      // Prepare payload for status update
      const payload = {
        id: singleJob?.id,
        status: newStatus,
      };

      // Dispatch updateJob action
      const result = await dispatch(updateJob(payload)).unwrap();

      if (result?.statusCode === 200) {
        // Update local state
        // setsingleJob((prev) => ({
        //   ...prev,
        //   status: newStatus,
        // }));

        // Update job status
        setJobStatus(newStatus);

        // Show success message

        openSnackbar("Job status updated successfully", "success");
        dispatch(getPostedJobs());
      }

      // Close popover
      setShowSelect(false);
      handleStatusClose(params);
    } catch (error) {
      console.error("Failed to update job status:", error);
      openSnackbar("Failed to update job status", "error");
    }
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: {
      xs: "90%",   // mobile
      sm: "70%",   // tablet
      md: "600px", // desktop
    },
    maxWidth: "90vw",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  };

  return (
    <Box
      sx={{
        width: "100%",
        padding: 2,
        display: "flex",
        flexDirection: "row",
        gap: "20px",
        backgroundColor: "rgba(244, 247, 254, 1)",
      }}
    >
      <Box sx={{ width: "70%" }}>
        <Grid container spacing={2}>
          {/* Top Boxes */}
          <Grid item xs={12} md={6}>
            <Stack spacing={2}>
              {/* Hiring Partner Info */}
              <Paper
                sx={{
                  padding: 1,
                  boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px",
                  overflow: "hidden",
                  height: "300px",
                }}
              >
                <Box
                  sx={{
                    width: "80%",
                    margin: "auto",
                    // boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                    boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px;",
                  }}
                >
                  <MyVisitingCard />
                </Box>
              </Paper>
              {/* </Grid> */}

              {/* <Grid item xs={12} md={6}> */}
              <Paper
                sx={{
                  padding: 2,
                  height: "40vh",
                  position: "relative",
                  boxSizing: "border-box",
                  margin: 0,
                  borderRadius: 2,
                  boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px",
                  // border:"1px solid red"
                }}
              >
                <RecruiterJobs />
              </Paper>
            </Stack>
          </Grid>

          {/* Bottom Boxes */}
          <Grid item xs={12} md={6}>
            {/* postedJobs */}
            {loading ? (
              <Paper
                sx={{
                  p: 2,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </Paper>
            ) : !postedJobs || postedJobs?.length === 0 ? (
              <NoJobsFound />
            ) : (
              <Paper
                sx={{
                  padding: 2,
                  height: "100%",
                  maxHeight: "83vh",
                  overflowY: "auto",
                  scrollbarWidth: "none",
                  display: "flex",
                  flexDirection: "column",
                  boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px",
                }}
              >
                <Box>
                  <Box
                    display="flex"
                    flexDirection={"row"}
                    justifyContent={"space-between"}
                    alignItems="center"
                    gap={1}
                  >
                    <Box
                      display="flex"
                      flexDirection={"row"}
                      alignItems="center"
                      gap={2}
                    >
                      <Avatar
                        // src={logourl[singleJob?.id]}
                        alt={singleJob?.company_name || "Company Logo"}
                        src={
                          singleJob?.company_logo
                            ? singleJob?.company_logo
                            : "https://www.shutterstock.com/image-vector/image-icon-trendy-flat-style-600nw-643080895.jpg"
                        }
                        sx={{
                          width: 70,
                          height: 70,
                          marginBottom: 1,
                          display: "flex", // Ensure flex behavior for alignment
                          alignItems: "center", // Center content vertically
                          justifyContent: "center", // Center content horizontally
                        }}
                      >
                        {singleJob?.company_name[0]}
                      </Avatar>
                      <Box display={"flex"} flexDirection={"column"}>
                        <Typography variant="h6">
                          {singleJob?.role || "Job Role"}
                        </Typography>
                        <Typography sx={{ fontSize: "14px" }}>
                          {singleJob?.company_name || "Company"}
                        </Typography>
                      </Box>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      {!showSelect ? (
                        <Box
                          onClick={handleStatusClick}
                          sx={{ cursor: "pointer" }}
                        >
                          <Chip
                            label={
                              singleJob?.status == "close"
                                ? "Closed"
                                : singleJob?.status
                            }
                            color={
                              singleJob?.status === "open" ? "success" : "error"
                            }
                            variant="outlined"
                          />
                        </Box>
                      ) : (
                        <FormControl size="small">
                          <Select
                            value={singleJob?.status || "open"}
                            onChange={(e) => {
                              setSelectedNewStatus(e.target.value);
                              setShowStatusConfirmation(true);
                              setShowSelect(false);
                            }}
                            onBlur={() => setShowSelect(false)}
                            displayEmpty
                            inputProps={{ "aria-label": "Job Status" }}
                            sx={{
                              height: "32px",
                              "& .MuiSelect-select": {
                                paddingY: "2px",
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor:
                                  singleJob?.status === "open"
                                    ? "success.main"
                                    : "error.main",
                              },
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor:
                                  singleJob?.status === "open"
                                    ? "success.main"
                                    : "error.main",
                              },
                            }}
                          >
                            <MenuItem value="open">open</MenuItem>
                            <MenuItem value="close">closed</MenuItem>
                          </Select>
                        </FormControl>
                      )}
                    </Box>
                  </Box>
                </Box>
                <Box
                  sx={{
                    flex: 1,
                    gap: 1,
                  }}
                >
                  <Stack
                    direction="row"
                    spacing={0.2}
                    flexWrap="wrap"
                    justifyContent="center"
                    paddingTop={2}
                  >
                    {applicants?.length > 0 ? (
                      <Box sx={{ width: "100%", position: "relative" }}>
                        {applicants?.length > 10 && (
                          <Typography
                            variant="caption"
                            sx={{ position: "absolute", right: 0, top: -20 }}
                          >
                            Total: {applicants?.length} candidates
                          </Typography>
                        )}
                        <Box sx={{ width: "100%" }}>
                          <Box
                            sx={{
                              width: "100%",

                              backgroundImage:
                                "linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(0, 0, 105, 1) 0%, rgba(0, 212, 255, 1) 100%)",
                              color: "white",
                              borderRadius: "10px",
                            }}
                          >
                            <Tabs
                              value={selectedTab}
                              onChange={handleTabChange}
                              sx={{
                                width: "100%",
                                "& .MuiTab-root": {
                                  color: "white",
                                  margin: "4px",
                                  borderRadius: "8px",
                                  "&.Mui-selected": {
                                    color: "white",
                                    border: "1px solid white",
                                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                                  },
                                },
                                "& .MuiTabs-indicator": {
                                  display: "none",
                                },
                              }}
                            >
                              <Tab label="Analytics" sx={{ flex: 1 }} />
                              <Tab label="Applicants" sx={{ flex: 1 }} />
                            </Tabs>
                          </Box>
                          {selectedTab === 0 && (
                            <Grid
                              container
                              spacing={2}
                              sx={{ width: "100%", p: 2 }}
                            >
                              {/* Total Applicants Box (Spans Two Columns) */}
                              <Grid item xs={12}>
                                <Box
                                  onClick={() => {
                                    handleStatsClick({
                                      status: "Total",
                                      value:
                                        singleJob?.applicantStats?.total || 0,
                                    });
                                    // setSelectedTab(1);
                                  }}
                                  sx={{
                                    width: "100%",
                                    maxHeight: "100px",
                                    maxWidth: "420px",
                                    p: 2,
                                    borderRadius: 2,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "left",
                                    gap: "10px",
                                    boxShadow:
                                      "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                                    border:
                                      selectedStatus === "All"
                                        ? "1px solid #0044C6"
                                        : "1px solid lightgray",

                                    backgroundColor: "#fff",
                                    m: "auto",
                                    transition: "all 0.3s ease",
                                    "&:hover": {
                                      boxShadow: "0 1px 2px lightgray",
                                      border: "1px solid #0044C6",
                                    },
                                  }}
                                >
                                  <img
                                    src={Total}
                                    alt="Total Applicants"
                                    style={{ width: 40, height: 40 }}
                                  />
                                  <Box>
                                    <Typography
                                      variant="h3"
                                      sx={{
                                        color: "#0044c6",
                                        fontWeight: "bold",
                                        fontSize: "20px",
                                      }}
                                    >
                                      {singleJob?.applicantStats?.total || 0}
                                    </Typography>
                                    <Typography
                                      variant="h6"
                                      sx={{
                                        color: "text.secondary",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Total Applicants
                                    </Typography>
                                  </Box>
                                </Box>
                              </Grid>

                              {/* Six Status Boxes */}
                              {statsConfig?.map((stat, index) => (
                                <Grid item xs={6} sm={6} key={index}>
                                  <Box
                                    onClick={() => handleStatsClick(stat)}
                                    sx={{
                                      width: "100%",
                                      maxHeight: "70px",
                                      maxWidth: "200px",
                                      p: 1,
                                      borderRadius: 2,
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      boxShadow:
                                        "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                                      border:
                                        selectedStatus === stat.status
                                          ? "1px solid #0044C6"
                                          : "1px solid lightgray",
                                      backgroundColor: "#fff",
                                      m: "auto",
                                      transition: "all 0.3s ease",
                                      "&:hover": {
                                        boxShadow: "0 1px 2px lightgray",
                                        border: "1px solid #0044C6",
                                      },
                                    }}
                                  >
                                    <Box>
                                      <Typography
                                        variant="h3"
                                        sx={{
                                          color: "#0044c6",
                                          fontWeight: "bold",
                                          fontSize: "18px",
                                        }}
                                      >
                                        {stat.value}
                                      </Typography>
                                      <Typography
                                        variant="h6"
                                        sx={{
                                          color: "text.secondary",
                                          fontSize: "14px",
                                        }}
                                      >
                                        {stat.label}
                                      </Typography>
                                    </Box>
                                    <img
                                      src={stat.image || "No Image found"}
                                      alt={stat.label}
                                      style={{ width: 30, height: 30 }}
                                    />
                                  </Box>
                                </Grid>
                              ))}

                              {/* Interview Activity Title */}
                              <Grid item xs={12}>
                                <Typography
                                  variant="h6"
                                  sx={{
                                    fontWeight: "bold",
                                    mt: 1,
                                    fontSize: "12px",
                                  }}
                                >
                                  Interview Activity
                                </Typography>
                              </Grid>

                              {/* Three Additional Boxes */}
                              {[
                                {
                                  label: "Schedule Interview",
                                  image: calender,
                                  onClick: () => {
                                    handleStatsClick({
                                      status: "Interview In-Progress",
                                      value:
                                        singleJob?.applicantStats?.[
                                          "Interview In-Progress"
                                        ] || 0,
                                    });
                                    // setSelectedTab(1);
                                  },
                                },
                                {
                                  label: "Send Offer Letter",
                                  image: interviewed,
                                  onClick: () => {
                                    handleStatsClick({
                                      status: "Selected",
                                      value:
                                        singleJob?.applicantStats?.[
                                          "Selected"
                                        ] || 0,
                                    });
                                    // setSelectedTab(1);
                                  },
                                },
                              ].map((action, index) => (
                                <Grid item xs={6} sm={6} key={index}>
                                  <Box
                                    onClick={action.onClick}
                                    sx={{
                                      width: "100%",
                                      maxHeight: "70px",
                                      maxWidth: "200px",
                                      p: 1,
                                      borderRadius: 2,
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      boxShadow:
                                        "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                                      // border: "1px solid lightgray",
                                      border:
                                        selectedStatus ===
                                        (action.label === "Schedule Interview"
                                          ? "Interview In-Progress"
                                          : "Selected")
                                          ? "1px solid #0044C6"
                                          : "1px solid lightgray",
                                      backgroundColor: "#fff",
                                      m: "auto",
                                      cursor: "pointer",
                                      transition: "all 0.3s ease",
                                      "&:hover": {
                                        boxShadow: "0 1px 2px lightgray",
                                        border: "1px solid #0044C6",
                                      },
                                    }}
                                  >
                                    <Typography
                                      variant="h6"
                                      sx={{
                                        color: "#0044c6",
                                        fontWeight: "bold",
                                        fontSize: "14px",
                                      }}
                                    >
                                      {action.label}
                                    </Typography>
                                    <img
                                      src={action.image}
                                      alt={action.label}
                                      style={{ width: 30, height: 30 }}
                                    />
                                  </Box>
                                </Grid>
                              ))}
                            </Grid>
                          )}

                          {selectedTab === 1 && (
                            <Box sx={{ p: 2 }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginBottom: 2,
                                }}
                              >
                                <Typography
                                  variant="h6"
                                  gutterBottom
                                  sx={{ fontSize: "14px" }}
                                >
                                  {selectedStatus === "all"
                                    ? "All Candidates"
                                    : `${selectedStatus} Candidates`}
                                </Typography>
                                <Box
                                  onClick={() =>
                                    handleViewAllCandidate(selectedStatus)
                                  }
                                >
                                  <Typography
                                    variant="h6"
                                    gutterBottom
                                    style={{
                                      textDecoration: "none",
                                      fontSize: "14px",
                                      cursor: "pointer",
                                      color: "#0044C6",
                                    }}
                                  >
                                    View All
                                  </Typography>
                                </Box>
                              </Box>
                              <Box
                                sx={{
                                  display: "grid",
                                  gridTemplateColumns: "repeat(2, 1fr)",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                {applicants?.slice(0, 10)?.map((app) => (
                                  <CandidateCard candidate={app} />
                                ))}
                              </Box>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          p: 3,
                          textAlign: "center",
                          border: "1px solid #eee",
                          borderRadius: 2,
                          backgroundColor: "#fff",
                        }}
                      >
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          sx={{ textAlign: "center" }}
                        >
                          No candidates applied for this job.
                        </Typography>
                      </Box>
                    )}
                  </Stack>
                </Box>
              </Paper>
            )}
          </Grid>

          <Grid item xs={12} md={6}>
            {/* jhvkhvghgcgjcjcchjghgh */}
          </Grid>
        </Grid>
      </Box>

      <Modal
        open={showStatusConfirmation}
        onClose={() => setShowStatusConfirmation(false)}
      >
        <Box sx={modalStyle}>
          <Typography variant="h6" gutterBottom>
            Confirm Status Change
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Are you sure you want to change the job status to "
            {selectedNewStatus}"?
          </Typography>
          <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
            <Button
              variant="outlined"
              onClick={() => setShowStatusConfirmation(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={async () => {
                try {
                  await handleStatusChange(selectedNewStatus);
                } finally {
                  setShowStatusConfirmation(false);
                }
              }}
            >
              Confirm
            </Button>
          </Box>
        </Box>
      </Modal>

      <Snackbar
        open={showSnackbar}
        autoHideDuration={6000}
        onClose={() => setShowSnackbar(false)}
      >
        <Alert onClose={() => setShowSnackbar(false)} severity="error">
          {error}
        </Alert>
      </Snackbar>
      <Box sx={{ width: "28%", minHeight: "75vh" }}>
        {/* <JobOpenings/> */}
        <JobDescriptionSidebar
          selectedJob={singleJob}
          logourl={
            "https://png.pngtree.com/png-clipart/20190611/original/pngtree-wolf-logo-png-image_2306634.jpg"
          }
        />
      </Box>
    </Box>
  );
};

export default RecruiterDashBoard;
